// extracted by mini-css-extract-plugin
export default {"selected":"d48e160608","un":"_2dc65108de"};